import { SET_USER_DETAILS } from '../store/actionTypes'

export const setUserDetails = (user) => (
  {
    type: SET_USER_DETAILS,
    payload: user,
  }
)
